export class FetchBarcodesAction {
  static readonly type = '[Barcodes] Fetch Barcodes';
}
